import { useCallback } from 'react';

import { addChild } from '~store/thunks/child';
import useAppDispatch from './useAppDispatch';

const useAddModuleFromTemplate = ({
  parentId,
  fieldName = 'relationships.field_modules.data',
}: {
  parentId: string;
  fieldName?: string;
}) => {
  const dispatch = useAppDispatch();
  return useCallback(
    (templateType: string, index = 0) => {
      dispatch(addChild({ id: parentId, index, fieldName, templateType }));
    },
    [dispatch, fieldName, parentId],
  );
};

export default useAddModuleFromTemplate;
